import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list.svg",
  "use": "list.svg-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32\" id=\"list.svg\"><path d=\"M7.5 5a2 2 0 012 2v1a2 2 0 01-2 2h-1a2 2 0 01-2-2V7a2 2 0 012-2h1zM14 6a1.5 1.5 0 000 3h13a1.5 1.5 0 000-3H14zM14 14a1.5 1.5 0 000 3h13a1.5 1.5 0 000-3H14zM12.5 23.5A1.5 1.5 0 0114 22h13a1.5 1.5 0 010 3H14a1.5 1.5 0 01-1.5-1.5zM9.5 15a2 2 0 00-2-2h-1a2 2 0 00-2 2v1a2 2 0 002 2h1a2 2 0 002-2v-1zM7.5 21a2 2 0 012 2v1a2 2 0 01-2 2h-1a2 2 0 01-2-2v-1a2 2 0 012-2h1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol